import { Entity } from '@core/api/entity';
import { Field, Model } from '@junte/serialize-ts';

// export type BasketStatus = 'published' | 'initiated' | 'accepted';

@Model()
export class PendingAreaContent extends Entity {
  @Field() titleEn: string;
  @Field() titleDe: string;
  @Field() contentHtmlEn: string;
  @Field() contentHtmlDe: string;
  @Field() order: number;

  public static create(data: Partial<PendingAreaContent>): PendingAreaContent {
    return Object.assign(new PendingAreaContent(), data);
  }
}
